import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsGlobalNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm-1.814 2.62l2.167 2.167c.016.016.02.027.022.034.003.01.004.025 0 .042s-.01.03-.016.038a.075.075 0 01-.034.023l-4.259 1.703a2.583 2.583 0 00-1.439 1.44l-2.122 5.305A2.584 2.584 0 008.93 16h-1.72a.084.084 0 01-.059-.024L3.1 12.008C4.63 7.06 8.929 3.327 14.186 2.621zM2.5 16c0-.35.013-.698.04-1.042l2.863 2.804a2.583 2.583 0 001.808.738h1.795a3.917 3.917 0 00.246 5.27l1.724 1.723a.084.084 0 01.024.06v2.99C6.02 26.558 2.5 21.69 2.5 16zM16 29.5c-.854 0-1.69-.08-2.5-.231v-3.717c0-.685-.272-1.342-.757-1.826l-1.724-1.724a1.417 1.417 0 010-2.004l1.499-1.498h2.963c.021 0 .041.008.057.022l4.865 4.46a.083.083 0 01.017.1l-3.305 6.373c-.367.03-.74.045-1.115.045zm13.463-12.486L25.5 14.042v-2.087l1.92-1.455h.912a13.453 13.453 0 011.13 6.514zm-.496 2.753a13.531 13.531 0 01-8.703 9.046l2.376-4.581a2.583 2.583 0 00-.548-3.094l-4.865-4.459A2.584 2.584 0 0015.481 16h-2.975l-1.66-1.609a.083.083 0 01-.02-.09l2.122-5.306a.083.083 0 01.047-.047l4.259-1.703c1.721-.689 2.178-2.914.867-4.225l-.413-.413a13.491 13.491 0 019.198 5.435 2.25 2.25 0 00-.929.415l-2.086 1.58A2.25 2.25 0 0023 11.83v2.337c0 .708.333 1.375.9 1.8z"
        fill=""
      />
    </svg>
  )
);
SvgActionsGlobalNormalMedium.defaultProps = {
  color: "currentColor",
  size: 32,
  title: undefined,
  titleId: undefined,
};
SvgActionsGlobalNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsGlobalNormalMedium;
